<template>
  <transition name="fade">
    <div :class="`customizer-3D-${cssName}`" v-show="showToolTip">
      <img v-if="asset" :src="asset" :alt="imageAlt"/>
      <div :class="`customizer-3D-${cssName}-text`">{{ translations[message] }}</div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "customToolTip",
  props: {
    showToolTip: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ""
    },
    asset: {
      type: String,
      default: ""
    },
    imageAlt: {
      type: String,
      default: ""
    },
    cssName: {
      type: String,
      default: ""
    }
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    }
  }
};
</script>
